{
  "version": 1,
  "asset_id": "95af55b7-7059-4a02-9887-ef343a2ac809",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/95af55b7-7059-4a02-9887-ef343a2ac809/hiatal-type-2-v3-1200.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/95af55b7-7059-4a02-9887-ef343a2ac809/hiatal-type-2-v3-1200.jpg",
  "original_filename": "hiatal-type-2-v3-1200.jpg",
  "size": 271303,
  "content_type": "image/jpeg",
  "created_at": "2026-10-28T19:42:10Z"
}
